import React from "react";
import {Spin} from "antd";

const LoadingScreen=()=>{

    return <div className="w-full bg-gray-900  flex justify-center items-center h-screen  fixed z-50">
        <Spin size="large" />
    </div>
}
export default LoadingScreen;